import React from "react";

const TrackOrderIconWMO = ({ height = "16", width = "16" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8173_284)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3772 3.61597H2.80514C2.5433 3.61597 2.29332 3.82819 2.24674 4.09004L1.01643 11.0069C0.969881 11.2686 1.14433 11.481 1.40618 11.481H2.11192C2.25333 10.686 3.0152 10.039 3.81022 10.039C4.60524 10.039 5.13696 10.686 4.99555 11.481H9.45232L10.767 4.09004C10.8135 3.82819 10.6391 3.61597 10.3772 3.61597ZM15.6604 8.08048L13.7753 5.0502C13.7328 4.98209 13.6279 4.92678 13.5405 4.92678H11.0769L9.91107 11.481H10.4354C10.5768 10.686 11.3385 10.039 12.1335 10.039C12.9286 10.039 13.4603 10.686 13.3189 11.481H14.6803C14.9421 11.481 15.1921 11.2686 15.2387 11.0069L15.7091 8.36192C15.7246 8.27469 15.703 8.14859 15.6604 8.08048ZM3.76356 10.3014C4.41415 10.3014 4.84927 10.8304 4.73355 11.481C4.61783 12.1316 3.99447 12.6608 3.34388 12.6608C2.69345 12.6608 2.25826 12.1313 2.37392 11.481C2.48961 10.8306 3.11313 10.3014 3.76356 10.3014ZM12.0874 10.3014C12.7376 10.3014 13.1729 10.8304 13.0572 11.481C12.9415 12.1316 12.3179 12.6608 11.6677 12.6608C11.0171 12.6608 10.5819 12.1313 10.6976 11.481C10.8132 10.8306 11.4368 10.3014 12.0874 10.3014ZM13.1232 5.58227L14.5911 7.94174H11.3927L11.8124 5.58227H13.1232Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_8173_284">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default TrackOrderIconWMO;
